import React from 'react';
import PropTypes from 'prop-types';
import {Box, Card, Flex, Text} from "rebass";
import {PositionBox} from "../Base";
import {schoolSelectors} from "../../store/school";
import {withFirebase} from "../Firebase";
import {connect} from "react-redux";
import {returnFilterString, returnWithRosterFilterString} from "../../utils";
import IosArrowUp from 'react-ionicons/lib/IosArrowUp'


const ResumeCheckin = props => {
	const {toggleRecentCheckin, checkin, schoolInfo, loadingSchool} = props;
	let title = 'All Students'
	if (!loadingSchool && checkin.filters) {
		title = returnFilterString(checkin.filters, schoolInfo)
	} 
	if(checkin.rosterFilter) {
		title = returnWithRosterFilterString(checkin.rosterFilter, title);
	}
	
	return (
		<PositionBox position={'fixed'} bottom={['69px', 0]} width={'100%'}>
			<Flex width={1} justifyContent={'center'}>
				<Card p={2} m={[0,3]} bg={'white'} width={[1, 0.5]} boxShadow={'main'}
				      onClick={toggleRecentCheckin}>

					<Flex justifyContent={'space-between'} flexWrap={'wrap'} flexDirection={'row'} width={1}>
						<Box width={1/4} p={1}>
							<IosArrowUp/>
						</Box>

						<Box width={1/2}>
							<Text textAlign={'center'} fontWeight={800}>Resume Check In</Text>
							<Text color='meta' textAlign='center' fontSize={'11px'}>{title}</Text>
						</Box>
						<Box width={1/4}/>
					</Flex>
				</Card>
			</Flex>
		</PositionBox>
	);
};

ResumeCheckin.propTypes = {
	toggleRecentCheckin: PropTypes.func,
	checkin: PropTypes.object
};

function mapStateToProps(state) {
	return {
		schoolInfo: schoolSelectors.refreshSchool(state.school),
		loadingSchool: schoolSelectors.isLoading(state.school)
	}
}

export default withFirebase(connect(
	mapStateToProps,
)(ResumeCheckin))
